export default __webpack_public_path__ + "static/who-3c002f3da4eeb045579e0dc18377ba0b.jpg";